<template>
  <div>
    <div class="skroutz-map-widget-container">
      <a ref="widgetElementOpenButton" href="javascript:void(0)" class="skroutz-map-widget-button"></a>
      <div
        v-show="
          getSelectedTransporterObject
          && getSelectedTransporterObject.class_name === transporter.class_name
          && widgetStateOpen
        "
        id="skroutzLockerMap"
      ></div>
      <button
        class="skroutz-map-widget-close-button"
        v-if="widgetStateOpen" @click="widgetStateOpen = false"
      >X</button>
    </div>
    <div v-if="getSmartPointIsSelected" class="smart_point-selection-input">
      <input type="hidden" name="smartPointJsonData" :value="JSON.stringify(getSelectedSmartPoint)">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../../../../vue/store'
import SmartPointModelDTO from '../SmartPointModelDTO'

export default {
  name: 'SkroutzLastMileWidget',
  data () {
    return {
      widgetStateOpen: false
    }
  },
  props: {
    transporter: {
      type: Object,
      required: true
    }
  },
  created () {
    this.$root.$on(`${this.transporter.class_name}_AfterSelect`, (payload) => {
      const smartPoint = new SmartPointModelDTO(
        payload.id,
        payload.name,
        payload.street_name + ' ' + payload.street_number,
        '',
        payload.lat,
        payload.lng,
        payload.zip
      )
      store.dispatch('setSelectedSmartPoint', smartPoint).then(() => {
        this.$root.$emit(`${this.transporter.class_name}_WidgetClose`)
      }).then(() => {
        this.$toasted.success(
          this.t('pickup.point.selected'), { duration: '2500' }
        )
        this.widgetStateOpen = false
      })
    })
    this.$root.$on(`${this.transporter.class_name}_WidgetOpen`, () => {
      this.clickOpenWidgetElement()
    })
  },
  destroyed () {
    this.$root.$off(`${this.transporter.class_name}_AfterSelect`)
    this.$root.$off(`${this.transporter.class_name}_WidgetOpen`)
  },
  computed: {
    ...mapGetters([
      'getSelectedSmartPoint',
      'getSelectedTransporterObject',
      'getSmartPointIsSelected'
    ])
  },
  methods: {
    addSelectedData (payload) {
      this.$set(this, 'selectedData', payload)
    },
    clickOpenWidgetElement () {
      if (this.$refs.widgetElementOpenButton) {
        this.$refs.widgetElementOpenButton.click()
        this.widgetStateOpen = true
      }
    }
  }
}
</script>

<style lang="scss">
  #skroutzLockerMap {
    iframe {
      z-index: 999999;
      top: 0;
      left: 0;
      display: flex;
      position: fixed;
      min-height: 100%;
      backdrop-filter: blur(1rem);
    }
  }
  .skroutz-map-widget-button {
    display: none;
  }
  .skroutz-map-widget-close-button {
    position: fixed;
    --bg-size: 48px;
    --fg-size: 24px;
    width: var(--bg-size);
    height: var(--bg-size);
    border: none;
    border-radius: 50%;
    background-color: #fff;
    color: #000;
    font-size: var(--fg-size);
    font-weight: 700;
    right: 2rem;
    top: 2rem;
    z-index: 999999;
    cursor: pointer;
    transition: all .2s ease-in-out;
    @media screen and (max-width: 714px) {
      top: 5.5rem;
    }
    &:hover {
      background-color: #000;
      color: #fff;
    }
  }
</style>
